import React, { FC } from 'react'
import styled from 'styled-components'
import { PaddedContentStyled, DescriptionTextStyled, SecondaryHeaderStyled } from '../../styles/shared'
import TextWithLinkStyled from '../common/textWithLinkStyled'
import { Carousel } from '../common'
import { ScreenBreakpointSize } from '../../utils/enums'
import { getScreenBreakpointSize } from '../../utils/getScreenBreakpointSize'
import { carouselData } from './carouselData'
import { StaticImage } from 'gatsby-plugin-image'

const ContainerStyled = styled.div`
  background: var(--background-gray);
  border: 1px solid var(--border-gray);
  border-radius: var(--border-radius-8);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: var(--spacing-90) auto 0;
  max-width: var(--page-title-max-width);
  text-align: center;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    border-radius: 0;
    align-items: flex-start;
    margin-top: var(--spacing-72);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    align-items: flex-start;
  }
`
const CustomSectionTitleStyled = styled(SecondaryHeaderStyled)`
  margin-top: var(--spacing-48);
  margin-bottom: var(--spacing-16);
  align-self: center;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    padding-left: var(--spacing-16);
  }
`
const CustomDescriptionTextStyled = styled(DescriptionTextStyled)`
  max-width: 49%;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    max-width: 80%;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    max-width: 70%;
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    max-width: 55%;
    padding: 0 var(--spacing-32);
  }
`
const LinkContainerStyled = styled.div`
  margin-top: var(--spacing-16);
  margin-bottom: var(--spacing-32);
  align-self: center;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    padding-left: var(--spacing-16);
  }
`

const PersonalKnowledgeBase: FC = () => {
  return (
    <PaddedContentStyled className="mb-[34px]">
      <ContainerStyled>
        <StaticImage
          className="border-solid border-b-8 border-blue"
          src={'../../assets/images/vault-wide.jpg'}
          alt="Vault"
        />

        <CustomSectionTitleStyled>A steel vault for your mind.</CustomSectionTitleStyled>
        <CustomDescriptionTextStyled>
          Standard Notes is a secure digital notes app that protects your notes and files with{' '}
          <strong>audited, industry-leading end-to-end encryption</strong>. Only you have access to the keys required to
          decrypt your data.
        </CustomDescriptionTextStyled>
        <CustomDescriptionTextStyled className="mt-20">
          Write and store all your notes and files in one secure place and seamlessly access them across all your
          devices.
        </CustomDescriptionTextStyled>
        <LinkContainerStyled>
          <TextWithLinkStyled text={'Explore our features'} targetUrl={'/features'} />
        </LinkContainerStyled>
        <Carousel data={carouselData} />
      </ContainerStyled>
    </PaddedContentStyled>
  )
}

export default PersonalKnowledgeBase
